/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { trackEvent } from "@util/ga";
import Card from "@components/cards/Card/Card";
import Button from "@components/buttons/Button/Button";
import styles from "@styles/CommonAuthPageLayout.module.css";
import LoadingSpinner from "@components/indicators/LoadingSpinner/LoadingSpinner";
import CheckIcon from "@components/display/CheckIcon/CheckIcon";
import AttributionForm from "@components/forms/AttributionForm/AttributionForm";
import { submitAttribution, verifyEmail } from "@services/userService";

const VerifyEmailPage = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const userId = searchParams.get("userId");
    const token = searchParams.get("token");
    const [success, setSuccess] = useState(false);

    const [source, setSource] = useState("");
    const [otherText, setOtherText] = useState("");

    useEffect(() => {
        async function process() {
            try {
                if (userId && token) {
                    await verifyEmail(userId, token);
                    setSuccess(true);
                    trackEvent("sign_up", {
                        method: "Email",
                    });
                } else {
                    throw new Error("User ID or token missing");
                }
            } catch (error) {
                alert("Error verifying email. Please try again");
                void navigate("/");
            }
        }
        void process();
    // Execute once on load
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleContinue = async () => {
        try {
            if (source && userId) {
                await submitAttribution(
                    userId,
                    source === "Other" ? "Other" : source,
                    source === "Other" ? otherText : undefined,
                );
            }
        } catch (err) {
            alert("Error submitting. Please try again");
        }
        void navigate("/auth/sign-in");
    };

    return (
        <div>
            {success ? (
                <Card className={styles.cardContainer}>
                    <div className={styles.linkContainer}>
                        <CheckIcon />
                        <p>Email successfully verified.</p>
                    </div>

                    <AttributionForm
                        source={source}
                        setSource={setSource}
                        otherText={otherText}
                        setOtherText={setOtherText}
                    />

                    <div className={styles.buttonLinkContainer}>
                        <Button variant="primary" onClick={handleContinue}>
                            Continue
                        </Button>
                    </div>
                </Card>
            ) : (
                <LoadingSpinner />
            )}
        </div>
    );
};

export default VerifyEmailPage;
